import * as signalR from '@microsoft/signalr'
import store from '@/store'
import { Notification, NotificationMessage } from './models'

// Load SignalR configuration URL
let connectionUrl: string | null = null
let configLoaded = false

function getCurrentUserId(): string {
  const raw = localStorage.getItem('currentUser')
  if (!raw) throw new Error('currentUser not found')

  const parsed = JSON.parse(raw)
  return parsed.userId.toString()
}

const loadConfig = async () => {
  try {
    connectionUrl = process.env.VUE_APP_SIGNALR_URL
    configLoaded = true
  } catch (error) {
    console.error('Failed to load SignalR config:', error)
  }
}

// Start loading config immediately
loadConfig()

class SignalRServiceClass {
  private connection: signalR.HubConnection

  constructor(userId: string) {
    if (!connectionUrl) {
      console.warn('SignalR config not yet loaded, connection will fail')
    }
    const urlWithUserId = `${connectionUrl}/notify?userId=${userId}`
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(urlWithUserId)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build()

    this.connection.on('ReceiveMessage', message => {
      //console.log('Received message:', message)
      store.dispatch('app/addMessage', message)
      store.commit('app/setToastMessage', message)
    })
  }
  public async sendMessage(payload: NotificationMessage): Promise<void> {
    try {
      if (payload.ByRole) {
        await this.connection.invoke('SendToRole', payload)
      } else {
        await this.connection.invoke('SendMessageToUser', payload)
      }
    } catch (err) {
      console.error('Error sending message:', err)
    }
  }
  public async startConnection(): Promise<void> {
    try {
      await this.connection.start()
      //console.log('SignalR connected')
    } catch (err) {
      console.error('SignalR connection error:', err)
      setTimeout(() => this.startConnection(), 5000)
    }
  }
  public async stopConnection(): Promise<void> {
    try {
      //console.log(this.connection)
      await this.connection.stop()
      //console.log('Connection stopped')
    } catch (err) {
      console.error('Error stopping connection:', err)
    }
  }

  public getConnection(): signalR.HubConnection {
    return this.connection
  }
}

// export default new SignalRService()
export default SignalRServiceClass

// You can create an instance separately if needed
// export const SignalRService = new SignalRServiceClass()
